import canUseDOM from "../canUseDOM";

export default canUseDOM ? window : {};



//////////////////
// WEBPACK FOOTER
// ./node_modules/inputmask/lib/global/window.js
// module id = 6xnS
// module chunks = 0